export const THEMES = {
  AICAPS: 'aicaps',
  JIU: 'jiu'
}

const STORAGE_KEY = 'faq_client_theme'

let changeHandler = null

export function getTheme() {
  const v = localStorage.getItem(STORAGE_KEY)
  return v === THEMES.JIU ? THEMES.JIU : THEMES.AICAPS
}

export function onThemeChange(fn) {
  changeHandler = fn
}

export function applyTheme(theme) {
  const root = document.documentElement
  root.classList.remove('theme-aicaps', 'theme-jiu')
  root.classList.add(`theme-${theme}`)
}

export function setTheme(theme) {
  const next = theme === THEMES.JIU ? THEMES.JIU : THEMES.AICAPS
  localStorage.setItem(STORAGE_KEY, next)
  applyTheme(next)
  if (changeHandler) changeHandler(next)
  return next
}

export function initTheme() {
  applyTheme(getTheme())
}
